(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sukr-spoon-story"] && !Shopify.designMode) return;
  try {
    
(()=>{
function init(root=document){root.querySelectorAll('[data-sk-lab]').forEach(lab=>{if(lab.dataset.ready)return;lab.dataset.ready='true';let timers=[];const stop=()=>{timers.forEach(clearTimeout);timers=[];};const show=step=>{lab.dataset.step=String(step);lab.querySelectorAll('[data-lab-step]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.labStep===String(step))));lab.querySelectorAll('[data-lab-panel]').forEach(p=>p.hidden=p.dataset.labPanel!==String(step));};const replay=()=>{stop();show(0);if(matchMedia('(prefers-reduced-motion: reduce)').matches)return;timers=[setTimeout(()=>show(1),1600),setTimeout(()=>show(2),3300)];};lab.addEventListener('click',e=>{const stage=e.target.closest('[data-lab-step]');const flavour=e.target.closest('[data-lab-flavour]');if(stage){stop();show(stage.dataset.labStep);}if(flavour){stop();lab.dataset.flavour=flavour.dataset.labFlavour;lab.querySelectorAll('[data-lab-flavour]').forEach(b=>b.setAttribute('aria-pressed',String(b===flavour)));lab.querySelectorAll('[data-lab-shop]').forEach(a=>a.hidden=a.dataset.labShop!==flavour.dataset.labFlavour);show(0);}if(e.target.closest('[data-lab-replay]'))replay();});lab.addEventListener('focusin',stop);const observer=new IntersectionObserver(entries=>{if(entries.some(entry=>entry.isIntersecting)){observer.disconnect();if(!lab.contains(document.activeElement))replay();}},{threshold:.35});observer.observe(lab);});}
init();document.addEventListener('shopify:section:load',e=>init(e.target));
})();

  } catch(e) { console.error(e); }
})();
})();
